import React, { useState, useRef, useEffect } from "react";
import "./whitelistwallets.scss";
import DataTable from "./DataTable/DataTable";
import { Dropdown, Modal } from "react-bootstrap";
import { REFUND_PROJECT_DATA } from "../../../utils/Constants";
import axios from "axios";
import { toast } from "react-toastify";
import { Api_Url } from "../../../utils/ApiUrl";
import Loader from "../../../hooks/loader";
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";

const Whitelistwallets = () => {
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [walletAddress, setWalletAddress] = useState("");
  const [whitelistData, setWhitelistData] = useState([]);
const [loader, setLoader] = useState(false);
  // Projects state for add/edit form
  const [projects, setProjects] = useState([
    { selectedToken: null, isOpen: false, price: "", amount: "" },
  ]);

  const containerRef = useRef(null);
  const [checkAdmin, isAdmin] = useAdminAllowed();
  const handleClose = () => {
    setShow(false);
    resetForm();
  };

  const handleShow = () => setShow(true);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  // Reset form state
  const resetForm = () => {
    setWalletAddress("");
    setProjects([{ selectedToken: null, isOpen: false, price: "", amount: "" }]);
    setIsEdit(false);
    setEditId(null);
  };

  // Fetch whitelist data
  const fetchWhitelistData = async () => {
    try {
      setLoader(true);
      const response = await axios.get(`${Api_Url}/credit/whiltelist`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      });

      if (response.data.statusCode === 200) {
        setWhitelistData(response.data.data);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching whitelist data:", error);
      toast.error("Failed to fetch whitelist data");
    }
  };

  // Handle edit whitelist
  const handleEdit = (wallet) => {
    setIsEdit(true);
    setEditId(wallet._id);
    setWalletAddress(wallet.by);

    // Format projects for the edit form
    const formattedProjects = wallet.projects.map(project => ({
      selectedToken: REFUND_PROJECT_DATA.find(token => token.value === project.privateSale) || null,
      isOpen: false,
      price: project.price.toString(),
      amount: project.tokens.toString()
    }));

    setProjects(formattedProjects);
    handleShow();
  };

  // Handle add/update whitelist wallet
  const handleAddUpdateWhitelist = async () => {
    if (!walletAddress) {
      toast.error("Please enter wallet address");
      return;
    }
    const isValidEthAddress = /^0x[a-fA-F0-9]{40}$/.test(walletAddress);
    if (!isValidEthAddress) {
      toast.error("Please enter a valid Ethereum wallet address");
      return;
    }
    // Validate projects
    const isValid = projects.every(project =>
      project.selectedToken && project.price && project.amount
    );

    if (!isValid) {
      toast.error("Please fill all project details");
      return;
    }

    // Check for duplicate projects
    const selectedProjects = projects.map(project => project.selectedToken?.value);
    const uniqueProjects = new Set(selectedProjects.filter(project => project !== undefined));

    if (uniqueProjects.size !== selectedProjects.length) {
      toast.error("Duplicate projects are not allowed");
      return;
    }

    setLoading(true);

    try {
      // Format projects for API
      const formattedProjects = projects.map(project => ({
        privateSale: project.selectedToken.value,
        price: parseFloat(project.price),
        tokens: parseInt(project.amount)
      }));

      const payload = {
        by: walletAddress?.toLowerCase(),
        projects: formattedProjects
      };

      let response;

      if (isEdit) {
        // Update existing whitelist
        response = await axios.patch(
          `${Api_Url}/credit/whiltelist`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
          }
        );
      } else {
        // Add new whitelist
        response = await axios.post(
          `${Api_Url}/credit/whiltelist`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
          }
        );
      }

      if (response.data.statusCode === 201) {
        handleClose();
        handleShow1();
        fetchWhitelistData();
      } else {
        toast.error(response.data.message || "Operation failed");
      }
    } catch (error) {
      console.error("Error adding/updating whitelist:", error);
      let errorMessage = error.response?.data?.message || "Operation failed";
      if(errorMessage === "by already exist") {
        toast.error('WalletAddress already exsist');
      }else{
        toast.error(errorMessage);
      }
     
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setProjects((prev) => [...prev, { selectedToken: null, isOpen: false, price: "", amount: "" }]);
  };

  const handleDelete = (index) => {
    if (projects.length > 1) {
      setProjects((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const handleToggle = (index) => {
    setProjects((prev) =>
      prev.map((proj, i) =>
        i === index
          ? { ...proj, isOpen: !proj.isOpen }
          : { ...proj, isOpen: false }
      )
    );
  };

  const handleSelect = (token, index) => {
    // Check if this project is already selected in another row
    const isAlreadySelected = projects.some(
      (proj, i) => i !== index && proj.selectedToken?.value === token.value
    );

    if (isAlreadySelected) {
      toast.error(`${token.value} is already added. Please select a different project.`);
      return;
    }

    setProjects((prev) =>
      prev.map((proj, i) =>
        i === index ? { ...proj, selectedToken: token, isOpen: false } : proj
      )
    );
  };

  const handleInputChange = (index, field, value) => {
    setProjects((prev) =>
      prev.map((proj, i) =>
        i === index ? { ...proj, [field]: value } : proj
      )
    );
  };

  useEffect(() => {
    fetchWhitelistData();
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [projects]);

  return (
    <>
      {loader && <Loader />}
      <section className="whitelistmain">
        <div className="custom-container">
          <div className="whitelisttop">
            <div className="whitelistleft">
              <p className="mainpara">Credit Refund</p>
              <h4 className="mainhead">Whitelist Wallets</h4>
            </div>
            {isAdmin && <button onClick={handleShow} className="whitelistbtn">
              Add Whitelist Wallet
            </button>}
          </div>
          <DataTable data={whitelistData} onEdit={handleEdit} fetchData={fetchWhitelistData} isAdmin={isAdmin}/>
        </div>
      </section>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="whitelistmodal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit Whitelist Wallet" : "Add Whitelist Wallet"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="walletpara">Wallet Address</p>
          <input
            type="text"
            placeholder="Enter wallet address here.."
            className="walletinput"
            value={walletAddress}
            onChange={(e) => setWalletAddress(e.target.value)}
          />
          <p className="walletpara">Add Project</p>
          <div
            ref={containerRef}
            className="mainaddproject"
            style={{
              maxHeight: projects.length > 1 ? "420px" : "100%",
              overflowY: projects.length > 1 ? "auto" : "visible",
            }}
          >
            {projects.map((project, index) => (
              <React.Fragment key={index}>
                <div className="selectmain">
                  <p className="selectpara">Select Project</p>
                  <Dropdown
                    show={project.isOpen}
                    onToggle={() => handleToggle(index)}
                  >
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      onClick={() => handleToggle(index)}
                    >
                      {!project.selectedToken ? (
                        <>Select Project</>
                      ) : (
                        <div className="tokeninner">
                          <div className="tokenimg">
                            <img
                              src={project.selectedToken.imageSrc}
                              alt={project.selectedToken.label}
                              className="innerimg"
                            />
                          </div>
                          <p className="tokenpara">
                            {project.selectedToken.value}
                          </p>
                        </div>
                      )}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="8"
                        viewBox="0 0 15 8"
                        fill="none"
                        style={{
                          rotate: project.isOpen ? "180deg" : "0deg",
                          transition: "rotate 0.3s ease-in-out",
                        }}
                      >
                        <path
                          d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                          fill="black"
                        />
                        <path
                          d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
                          fill="black"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="tokenmain">
                        {REFUND_PROJECT_DATA.map((token, i) => {
                          // Check if this token is already selected in another project row
                          const isDisabled = projects.some(
                            (proj, projIndex) =>
                              projIndex !== index &&
                              proj.selectedToken?.value === token.value
                          );

                          return (
                            <div
                              key={i}
                              className={`tokeninner ${isDisabled ? 'disabled-token' : ''}`}
                              onClick={() => !isDisabled && handleSelect(token, index)}
                              style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                opacity: isDisabled ? 0.5 : 1
                              }}
                            >
                              <div className="tokenimg">
                                <img
                                  src={token.imageSrc}
                                  alt={token.label}
                                  className="innerimg"
                                />
                              </div>
                              <p className="tokenpara">
                                {token.value}
                                {isDisabled && " (Already added)"}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                  <div className="innerselect">
                    <div className="maininput">
                      <p className="selectpara">Price</p>
                      <input
                        type="text"
                        className="innerinput"
                        placeholder="Price"
                        value={project.price}
                        onChange={(e) => handleInputChange(index, "price", e.target.value)}
                      />
                    </div>
                    <div className="maininput">
                      <p className="selectpara">Amount</p>
                      <input
                        type="text"
                        className="innerinput"
                        placeholder="Amount"
                        value={project.amount}
                        onChange={(e) => handleInputChange(index, "amount", e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="lastbtns">
                  {projects.length > 1 && (
                    <button
                      className="deletebtn"
                      onClick={() => handleDelete(index)}
                    >
                      Delete
                    </button>
                  )}
                  {index === projects.length - 1 && (
                    <button className="addbtn" onClick={handleAdd}>
                      Add Another Project
                    </button>
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>
          <div className="bottombtns">
            <button onClick={handleClose} className="btn-dull" disabled={loading}>
              Cancel
            </button>
            <button
              onClick={handleAddUpdateWhitelist}
              className="btn-green"
              disabled={loading}
            >
              {loading ? "Processing..." : isEdit ? "Update" : "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show1}
        onHide={handleClose1}
        centered
        className="whitelistmodal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="81"
            viewBox="0 0 80 81"
            fill="none"
            className="tickimg"
          >
            <path
              d="M40.0002 78.3945C60.9289 78.3945 77.8949 61.4284 77.8949 40.4997C77.8949 19.571 60.9289 2.60498 40.0002 2.60498C19.0715 2.60498 2.10547 19.571 2.10547 40.4997C2.10547 61.4284 19.0715 78.3945 40.0002 78.3945Z"
              fill="#329879"
            />
            <path
              d="M36.126 54.9C35.5786 54.9 35.0312 54.6894 34.6523 54.2684L22.947 42.5631C22.1049 41.721 22.1049 40.4157 22.947 39.5736C23.7891 38.7315 25.0944 38.7315 25.9365 39.5736L35.9996 49.6368L54.0207 26.9C54.7365 25.9736 56.0839 25.8473 56.9681 26.5631C57.8944 27.2789 58.0207 28.6263 57.3049 29.5105L37.8102 54.1C37.4312 54.5631 36.8839 54.8579 36.2944 54.9C36.2102 54.9 36.1681 54.9 36.126 54.9Z"
              fill="#E2E9EC"
            />
          </svg>
          <p className="successpara">Whitelist Wallet Successfully {isEdit ? "Updated" : "Added"}</p>
          <div className="bottombtns">
            <button onClick={handleClose1} className="btn-green">
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Whitelistwallets;
// v2
// import React, { useState, useRef, useEffect } from "react";
// import "./whitelistwallets.scss";
// import DataTable from "./DataTable/DataTable";
// import { Dropdown, Modal } from "react-bootstrap";
// import { REFUND_PROJECT_DATA } from "../../../utils/Constants";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { Api_Url } from "../../../utils/ApiUrl";

// const Whitelistwallets = () => {
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [isEdit, setIsEdit] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [walletAddress, setWalletAddress] = useState("");
//   const [whitelistData, setWhitelistData] = useState([]);

//   // Projects state for add/edit form
//   const [projects, setProjects] = useState([
//     { selectedToken: null, isOpen: false, price: "", amount: "" },
//   ]);

//   const containerRef = useRef(null);

//   const handleClose = () => {
//     setShow(false);
//     resetForm();
//   };

//   const handleShow = () => setShow(true);
//   const handleClose1 = () => setShow1(false);
//   const handleShow1 = () => setShow1(true);

//   // Reset form state
//   const resetForm = () => {
//     setWalletAddress("");
//     setProjects([{ selectedToken: null, isOpen: false, price: "", amount: "" }]);
//     setIsEdit(false);
//     setEditId(null);
//   };

//   // Fetch whitelist data
//   const fetchWhitelistData = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}/credit/whiltelist`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`
//         }
//       });

//       if (response.data.statusCode === 201) {
//         setWhitelistData(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching whitelist data:", error);
//       toast.error("Failed to fetch whitelist data");
//     }
//   };

//   // Handle edit whitelist
//   const handleEdit = (wallet) => {
//     setIsEdit(true);
//     setEditId(wallet._id);
//     setWalletAddress(wallet.by);

//     // Format projects for the edit form
//     const formattedProjects = wallet.projects.map(project => ({
//       selectedToken: REFUND_PROJECT_DATA.find(token => token.value === project.privateSale) || null,
//       isOpen: false,
//       price: project.price.toString(),
//       amount: project.tokens.toString()
//     }));

//     setProjects(formattedProjects);
//     handleShow();
//   };

//   // Handle add/update whitelist wallet
//   const handleAddUpdateWhitelist = async () => {
//     if (!walletAddress) {
//       toast.error("Please enter wallet address");
//       return;
//     }

//     // Validate projects
//     const isValid = projects.every(project =>
//       project.selectedToken && project.price && project.amount
//     );

//     if (!isValid) {
//       toast.error("Please fill all project details");
//       return;
//     }

//     setLoading(true);

//     try {
//       // Format projects for API
//       const formattedProjects = projects.map(project => ({
//         privateSale: project.selectedToken.value,
//         price: parseFloat(project.price),
//         tokens: parseInt(project.amount)
//       }));

//       const payload = {
//         by: walletAddress,
//         projects: formattedProjects
//       };

//       let response;

//       if (isEdit) {
//         // Update existing whitelist
//         response = await axios.patch(
//           `${Api_Url}/credit/whiltelist`,
//           payload,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("accessToken")}`
//             }
//           }
//         );
//       } else {
//         // Add new whitelist
//         response = await axios.post(
//           `${Api_Url}/credit/whiltelist`,
//           payload,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("accessToken")}`
//             }
//           }
//         );
//       }

//       if (response.data.statusCode === 201) {
//         handleClose();
//         handleShow1();
//         fetchWhitelistData();
//       } else {
//         toast.error(response.data.message || "Operation failed");
//       }
//     } catch (error) {
//       console.error("Error adding/updating whitelist:", error);
//       toast.error(error.response?.data?.message || "Operation failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAdd = () => {
//     setProjects((prev) => [...prev, { selectedToken: null, isOpen: false, price: "", amount: "" }]);
//   };

//   const handleDelete = (index) => {
//     if (projects.length > 1) {
//       setProjects((prev) => prev.filter((_, i) => i !== index));
//     }
//   };

//   const handleToggle = (index) => {
//     setProjects((prev) =>
//       prev.map((proj, i) =>
//         i === index
//           ? { ...proj, isOpen: !proj.isOpen }
//           : { ...proj, isOpen: false }
//       )
//     );
//   };

//   const handleSelect = (token, index) => {
//     setProjects((prev) =>
//       prev.map((proj, i) =>
//         i === index ? { ...proj, selectedToken: token, isOpen: false } : proj
//       )
//     );
//   };

//   const handleInputChange = (index, field, value) => {
//     setProjects((prev) =>
//       prev.map((proj, i) =>
//         i === index ? { ...proj, [field]: value } : proj
//       )
//     );
//   };

//   useEffect(() => {
//     fetchWhitelistData();
//   }, []);

//   useEffect(() => {
//     if (containerRef.current) {
//       containerRef.current.scrollTop = containerRef.current.scrollHeight;
//     }
//   }, [projects]);

//   return (
//     <>
//       <section className="whitelistmain">
//         <div className="custom-container">
//           <div className="whitelisttop">
//             <div className="whitelistleft">
//               <p className="mainpara">Credit Refund</p>
//               <h4 className="mainhead">Whitelist Wallets</h4>
//             </div>
//             <button onClick={handleShow} className="whitelistbtn">
//               Add Whitelist Wallet
//             </button>
//           </div>
//           <DataTable data={whitelistData} onEdit={handleEdit} fetchData={fetchWhitelistData} />
//         </div>
//       </section>

//       <Modal
//         show={show}
//         onHide={handleClose}
//         centered
//         className="whitelistmodal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{isEdit ? "Edit Whitelist Wallet" : "Add Whitelist Wallet"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p className="walletpara">Wallet Address</p>
//           <input
//             type="text"
//             placeholder="Enter wallet address here.."
//             className="walletinput"
//             value={walletAddress}
//             onChange={(e) => setWalletAddress(e.target.value)}
//           />
//           <p className="walletpara">Add Project</p>
//           <div
//             ref={containerRef}
//             className="mainaddproject"
//             style={{
//               maxHeight: projects.length > 1 ? "420px" : "100%",
//               overflowY: projects.length > 1 ? "auto" : "visible",
//             }}
//           >
//             {projects.map((project, index) => (
//               <React.Fragment key={index}>
//                 <div className="selectmain">
//                   <p className="selectpara">Select Project</p>
//                   <Dropdown
//                     show={project.isOpen}
//                     onToggle={() => handleToggle(index)}
//                   >
//                     <Dropdown.Toggle
//                       variant="success"
//                       id="dropdown-basic"
//                       onClick={() => handleToggle(index)}
//                     >
//                       {!project.selectedToken ? (
//                         <>Select Project</>
//                       ) : (
//                         <div className="tokeninner">
//                           <div className="tokenimg">
//                             <img
//                                 src={project.selectedToken.imageSrc}
//                                 alt={project.selectedToken.label}
//                               className="innerimg"
//                             />
//                           </div>
//                           <p className="tokenpara">
//                             {project.selectedToken.value}
//                           </p>
//                         </div>
//                       )}
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="15"
//                         height="8"
//                         viewBox="0 0 15 8"
//                         fill="none"
//                         style={{
//                           rotate: project.isOpen ? "180deg" : "0deg",
//                           transition: "rotate 0.3s ease-in-out",
//                         }}
//                       >
//                         <path
//                           d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
//                           fill="black"
//                         />
//                         <path
//                           d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
//                           fill="black"
//                         />
//                       </svg>
//                     </Dropdown.Toggle>

//                     <Dropdown.Menu>
//                       <div className="tokenmain">
//                         {REFUND_PROJECT_DATA.map((token, i) => (
//                           <div
//                             key={i}
//                             className="tokeninner"
//                             onClick={() => handleSelect(token, index)}
//                             style={{ cursor: "pointer" }}
//                           >
//                             <div className="tokenimg">
//                               <img
//                                 src={token.imageSrc}
//                                 alt={token.label}
//                                 className="innerimg"
//                               />
//                             </div>
//                             <p className="tokenpara">{token.value}</p>
//                           </div>
//                         ))}
//                       </div>
//                     </Dropdown.Menu>
//                   </Dropdown>
//                   <div className="innerselect">
//                     <div className="maininput">
//                       <p className="selectpara">Price</p>
//                       <input
//                         type="text"
//                         className="innerinput"
//                         placeholder="Price"
//                         value={project.price}
//                         onChange={(e) => handleInputChange(index, "price", e.target.value)}
//                       />
//                     </div>
//                     <div className="maininput">
//                       <p className="selectpara">Amount</p>
//                       <input
//                         type="text"
//                         className="innerinput"
//                         placeholder="Amount"
//                         value={project.amount}
//                         onChange={(e) => handleInputChange(index, "amount", e.target.value)}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="lastbtns">
//                   {projects.length > 1 && (
//                     <button
//                       className="deletebtn"
//                       onClick={() => handleDelete(index)}
//                     >
//                       Delete
//                     </button>
//                   )}
//                   {index === projects.length - 1 && (
//                     <button className="addbtn" onClick={handleAdd}>
//                       Add Another Project
//                     </button>
//                   )}
//                 </div>
//               </React.Fragment>
//             ))}
//           </div>
//           <div className="bottombtns">
//             <button onClick={handleClose} className="btn-dull" disabled={loading}>
//               Cancel
//             </button>
//             <button
//               onClick={handleAddUpdateWhitelist}
//               className="btn-green"
//               disabled={loading}
//             >
//               {loading ? "Processing..." : isEdit ? "Update" : "Add"}
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>

//       <Modal
//         show={show1}
//         onHide={handleClose1}
//         centered
//         className="whitelistmodal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Success</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="80"
//             height="81"
//             viewBox="0 0 80 81"
//             fill="none"
//             className="tickimg"
//           >
//             <path
//               d="M40.0002 78.3945C60.9289 78.3945 77.8949 61.4284 77.8949 40.4997C77.8949 19.571 60.9289 2.60498 40.0002 2.60498C19.0715 2.60498 2.10547 19.571 2.10547 40.4997C2.10547 61.4284 19.0715 78.3945 40.0002 78.3945Z"
//               fill="#329879"
//             />
//             <path
//               d="M36.126 54.9C35.5786 54.9 35.0312 54.6894 34.6523 54.2684L22.947 42.5631C22.1049 41.721 22.1049 40.4157 22.947 39.5736C23.7891 38.7315 25.0944 38.7315 25.9365 39.5736L35.9996 49.6368L54.0207 26.9C54.7365 25.9736 56.0839 25.8473 56.9681 26.5631C57.8944 27.2789 58.0207 28.6263 57.3049 29.5105L37.8102 54.1C37.4312 54.5631 36.8839 54.8579 36.2944 54.9C36.2102 54.9 36.1681 54.9 36.126 54.9Z"
//               fill="#E2E9EC"
//             />
//           </svg>
//           <p className="successpara">Whitelist Wallet Successfully {isEdit ? "Updated" : "Added"}</p>
//           <div className="bottombtns">
//             <button onClick={handleClose1} className="btn-green">
//               Close
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Whitelistwallets;


// v1 
// import React, { useState, useRef, useEffect } from "react";
// import "./whitelistwallets.scss";
// import DataTable from "./DataTable/DataTable";
// import { Dropdown, Modal } from "react-bootstrap";
// import { REFUND_PROJECT_DATA } from "../../../utils/Constants";

// const Whitelistwallets = () => {
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const [show1, setShow1] = useState(false);

//   const handleClose1 = () => setShow1(false);
//   const handleShow1 = () => setShow1(true);



//   const [selectedToken, setSelectedToken] = useState(null);
//   const [isOpen, setIsOpen] = useState(false);

//   const [projects, setProjects] = useState([
//     { selectedToken: null, isOpen: false },
//   ]);

//   const containerRef = useRef(null);

//   const handleAdd = () => {
//     setProjects((prev) => [...prev, { selectedToken: null, isOpen: false }]);
//   };

//   const handleDelete = (index) => {
//     if (projects.length > 1) {
//       setProjects((prev) => prev.filter((_, i) => i !== index));
//     }
//   };

//   const handleToggle = (index) => {
//     setProjects((prev) =>
//       prev.map((proj, i) =>
//         i === index
//           ? { ...proj, isOpen: !proj.isOpen }
//           : { ...proj, isOpen: false }
//       )
//     );
//   };

//   const handleSelect = (token, index) => {
//     setProjects((prev) =>
//       prev.map((proj, i) =>
//         i === index ? { ...proj, selectedToken: token, isOpen: false } : proj
//       )
//     );
//   };

//   useEffect(() => {
//     if (containerRef.current) {
//       containerRef.current.scrollTop = containerRef.current.scrollHeight;
//     }
//   }, [projects]);

//   return (
//     <>
//       <section className="whitelistmain">
//         <div className="custom-container">
//           <div className="whitelisttop">
//             <div className="whitelistleft">
//               <p className="mainpara">Credit Refund</p>
//               <h4 className="mainhead">Whitelist Wallets</h4>
//             </div>
//             <button onClick={handleShow} className="whitelistbtn">
//               Add Whitelist Wallet
//             </button>
//           </div>
//           <DataTable />
//         </div>
//       </section>

//       <Modal
//         show={show}
//         onHide={handleClose}
//         centered
//         className="whitelistmodal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Whitelist Wallet</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p className="walletpara">Wallet Address</p>
//           <input
//             type="text"
//             placeholder="Enter wallet address here.."
//             className="walletinput"
//           />
//           <p className="walletpara">Add Project</p>
//           <div
//             ref={containerRef}
//             className="mainaddproject"
//             style={{
//               maxHeight: projects.length > 1 ? "420px" : "100%",
//               overflowY: projects.length > 1 ? "auto" : "visible",
//             }}
//           >
//             {projects.map((project, index) => (
//               <>
//                 <div className="selectmain" key={index}>
//                   <p className="selectpara">Select Project</p>
//                   <Dropdown
//                     show={project.isOpen}
//                     onToggle={() => handleToggle(index)}
//                   >
//                     <Dropdown.Toggle
//                       variant="success"
//                       id="dropdown-basic"
//                       onClick={() => handleToggle(index)}
//                     >
//                       {!project.selectedToken ? (
//                         <>Select Project</>
//                       ) : (
//                         <div className="tokeninner">
//                           <div className="tokenimg">
//                             <img
//                               src={project.selectedToken.icon}
//                               alt={project.selectedToken.name}
//                               className="innerimg"
//                             />
//                           </div>
//                           <p className="tokenpara">
//                             {project.selectedToken.name}
//                           </p>
//                         </div>
//                       )}
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="15"
//                         height="8"
//                         viewBox="0 0 15 8"
//                         fill="none"
//                         style={{
//                           rotate: project.isOpen ? "180deg" : "0deg",
//                           transition: "rotate 0.3s ease-in-out",
//                         }}
//                       >
//                         <path
//                           d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
//                           fill="black"
//                         />
//                         <path
//                           d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
//                           fill="black"
//                         />
//                       </svg>
//                     </Dropdown.Toggle>

//                     <Dropdown.Menu>
//                       <div className="tokenmain">
//                         {REFUND_PROJECT_DATA.map((token, i) => (
//                           <div
//                             key={i}
//                             className="tokeninner"
//                             onClick={() => handleSelect(token, index)}
//                             style={{ cursor: "pointer" }}
//                           >
//                             <div className="tokenimg">
//                               <img
//                                 src={token.imageSrc}
//                                 alt={token.label}
//                                 className="innerimg"
//                               />
//                             </div>
//                             <p className="tokenpara">{token.value}</p>
//                           </div>
//                         ))}
//                       </div>
//                     </Dropdown.Menu>
//                   </Dropdown>
//                   <div className="innerselect">
//                     <div className="maininput">
//                       <p className="selectpara">Price</p>
//                       <input
//                         type="text"
//                         className="innerinput"
//                         placeholder="Price"
//                       />
//                     </div>
//                     <div className="maininput">
//                       <p className="selectpara">Amount</p>
//                       <input
//                         type="text"
//                         className="innerinput"
//                         placeholder="Amount"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="lastbtns">
//                   {projects.length > 1 && (
//                     <button
//                       className="deletebtn"
//                       onClick={() => handleDelete(index)}
//                     >
//                       Delete
//                     </button>
//                   )}
//                   {index === projects.length - 1 && (
//                     <button className="addbtn" onClick={handleAdd}>
//                       Add Another Project
//                     </button>
//                   )}
//                 </div>
//               </>
//             ))}
//           </div>
//           <div className="bottombtns">
//             <button onClick={handleClose} className="btn-dull">
//               Cancel
//             </button>
//             <button
//               onClick={() => {
//                 handleClose();
//                 handleShow1();
//               }}
//               className="btn-green"
//             >
//               Add
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>

//       <Modal
//         show={show1}
//         onHide={handleClose1}
//         centered
//         className="whitelistmodal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Success</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="80"
//             height="81"
//             viewBox="0 0 80 81"
//             fill="none"
//              className="tickimg"
//           >
//             <path
//               d="M40.0002 78.3945C60.9289 78.3945 77.8949 61.4284 77.8949 40.4997C77.8949 19.571 60.9289 2.60498 40.0002 2.60498C19.0715 2.60498 2.10547 19.571 2.10547 40.4997C2.10547 61.4284 19.0715 78.3945 40.0002 78.3945Z"
//               fill="#329879"
//             />
//             <path
//               d="M36.126 54.9C35.5786 54.9 35.0312 54.6894 34.6523 54.2684L22.947 42.5631C22.1049 41.721 22.1049 40.4157 22.947 39.5736C23.7891 38.7315 25.0944 38.7315 25.9365 39.5736L35.9996 49.6368L54.0207 26.9C54.7365 25.9736 56.0839 25.8473 56.9681 26.5631C57.8944 27.2789 58.0207 28.6263 57.3049 29.5105L37.8102 54.1C37.4312 54.5631 36.8839 54.8579 36.2944 54.9C36.2102 54.9 36.1681 54.9 36.126 54.9Z"
//               fill="#E2E9EC"
//             />
//           </svg>
//           <p className="successpara">Whitelist Wallet Successfully Added</p>
//           <div className="bottombtns">
//             <button onClick={handleClose1} className="btn-green">
//               Close
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Whitelistwallets;
